import React from 'react'
import styled from 'styled-components'
import { IGif } from '@giphy/js-types'
import VideoPreview from 'shared/components/video-preview-thumbnail'
import VideoPreviewPlayInline from 'shared/components/video-inline-play'
import { SectionHeader } from '@giphy/react-giphy-brand'
import PlayBoxIcon from 'shared/components/icons/video/play'
import Arrow from 'shared/components/giphy-marketers/icons/arrow'
import { giphyLightGrey } from '@giphy/js-brand'
import { Experiment, Variant } from 'react-optimize'

const PREVIEW_WIDTH = 215
const SEARCH_WIDTH = 161
const LABEL_PADDING = 6
const ARROW_ROTATE = 270

const Container = styled.div`
    width: 100%;
    overflow: hidden;
`

const ContainerHeader = styled(SectionHeader)`
    display: flex;
    align-items: center;
    color: ${giphyLightGrey};
`
const ArrowContainer = styled.div`
    margin-left: 5px;
`
const PlayArrowContainer = styled(ArrowContainer)``

const Carousel = styled.div`
    display: flex;
    overflow-y: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
`

const Title = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 5px;
    box-sizing: border-box;
    margin-bottom: 5px;
`

const PreviewContainer = styled.div`
    margin-right: 5px;

    &:last-child {
        margin-right: 0;
    }
`

type VideoPreviewCarouselProps = {
    previews: IGif[]
    isSearch?: boolean
}

const MOBILE_EXPERIMENT_ID = 'SUqwuX8lSNKMQZCofCuiIw'

const VideoPreviewCarousel = ({ previews, isSearch }: VideoPreviewCarouselProps) => {
    return (
        <Container>
            {!isSearch && (
                <Title>
                    <ContainerHeader>
                        {`Today's Clips`}
                        <PlayArrowContainer>
                            <PlayBoxIcon size={{ width: 25, height: 25 }} />
                        </PlayArrowContainer>
                    </ContainerHeader>
                    <ContainerHeader>
                        See All
                        <ArrowContainer>
                            <Arrow rotate={ARROW_ROTATE} />
                        </ArrowContainer>
                    </ContainerHeader>
                </Title>
            )}
            <Carousel>
                {previews.map(preview => (
                    <PreviewContainer key={preview.slug}>
                        {isSearch ? (
                            <Experiment id={MOBILE_EXPERIMENT_ID}>
                                <Variant id="0">
                                    <VideoPreview
                                        gif={preview}
                                        width={SEARCH_WIDTH}
                                        labelPadding={LABEL_PADDING}
                                        preventDefault={false}
                                        playButtonSize={{ height: 27, width: 27 }}
                                        hideAttribution
                                        hideLabel
                                    />
                                </Variant>
                                <Variant id="1">
                                    <VideoPreview
                                        gif={preview}
                                        width={SEARCH_WIDTH}
                                        labelPadding={LABEL_PADDING}
                                        preventDefault={false}
                                        playButtonSize={{ height: 27, width: 27 }}
                                        hideAttribution
                                        hideLabel={false}
                                    />
                                </Variant>
                                <Variant id="2">
                                    <VideoPreviewPlayInline
                                        gif={preview}
                                        width={SEARCH_WIDTH}
                                        volumeSize={36}
                                        withOverlay={false}
                                        showClipTitle={false}
                                        playOnHover={false}
                                    />
                                </Variant>
                                <Variant id="3">
                                    <VideoPreviewPlayInline
                                        gif={preview}
                                        width={SEARCH_WIDTH}
                                        volumeSize={36}
                                        withOverlay={false}
                                        showClipTitle={true}
                                        playOnHover={false}
                                    />
                                </Variant>
                            </Experiment>
                        ) : (
                            <VideoPreview gif={preview} width={PREVIEW_WIDTH} labelPadding={LABEL_PADDING} />
                        )}
                    </PreviewContainer>
                ))}
            </Carousel>
        </Container>
    )
}

export default VideoPreviewCarousel
